/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { PracticalExamAttachmentPagesCountDto } from '../models';
/**
 * PracticalExamReportAttachmentPreviewApi - axios parameter creator
 * @export
 */
export const PracticalExamReportAttachmentPreviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Render a single PDF page as PNG with watermark (admin)
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamAttachmentPagePreview: async (attachmentId: number, pageIndex: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getPracticalExamAttachmentPagePreview', 'attachmentId', attachmentId)
            // verify required parameter 'pageIndex' is not null or undefined
            assertParamExists('getPracticalExamAttachmentPagePreview', 'pageIndex', pageIndex)
            const localVarPath = `/api/v2/practical-exam-report-attachments/{attachmentId}/pages/{pageIndex}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"pageIndex"}}`, encodeURIComponent(String(pageIndex)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Number of pages in a PDF attachment (admin)
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamAttachmentPagesCount: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getPracticalExamAttachmentPagesCount', 'attachmentId', attachmentId)
            const localVarPath = `/api/v2/practical-exam-report-attachments/{attachmentId}/pages-count`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Render a single PDF page from a shared attachment (public, via share token)
         * @param {string} token 
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamSharedAttachmentPagePreview: async (token: string, attachmentId: number, pageIndex: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getPracticalExamSharedAttachmentPagePreview', 'token', token)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getPracticalExamSharedAttachmentPagePreview', 'attachmentId', attachmentId)
            // verify required parameter 'pageIndex' is not null or undefined
            assertParamExists('getPracticalExamSharedAttachmentPagePreview', 'pageIndex', pageIndex)
            const localVarPath = `/api/v1/public/practical-exam-shares/{token}/attachments/{attachmentId}/pages/{pageIndex}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"pageIndex"}}`, encodeURIComponent(String(pageIndex)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Number of pages in a shared PDF attachment (public, via share token)
         * @param {string} token 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamSharedAttachmentPagesCount: async (token: string, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getPracticalExamSharedAttachmentPagesCount', 'token', token)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getPracticalExamSharedAttachmentPagesCount', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/public/practical-exam-shares/{token}/attachments/{attachmentId}/pages-count`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamReportAttachmentPreviewApi - functional programming interface
 * @export
 */
export const PracticalExamReportAttachmentPreviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamReportAttachmentPreviewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Render a single PDF page as PNG with watermark (admin)
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamAttachmentPagePreview(attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamAttachmentPagePreview(attachmentId, pageIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamReportAttachmentPreviewApi.getPracticalExamAttachmentPagePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Number of pages in a PDF attachment (admin)
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamAttachmentPagesCount(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamAttachmentPagesCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamAttachmentPagesCount(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamReportAttachmentPreviewApi.getPracticalExamAttachmentPagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Render a single PDF page from a shared attachment (public, via share token)
         * @param {string} token 
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamSharedAttachmentPagePreview(token: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamSharedAttachmentPagePreview(token, attachmentId, pageIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamReportAttachmentPreviewApi.getPracticalExamSharedAttachmentPagePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Number of pages in a shared PDF attachment (public, via share token)
         * @param {string} token 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamSharedAttachmentPagesCount(token: string, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamAttachmentPagesCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamSharedAttachmentPagesCount(token, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamReportAttachmentPreviewApi.getPracticalExamSharedAttachmentPagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamReportAttachmentPreviewApi - factory interface
 * @export
 */
export const PracticalExamReportAttachmentPreviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamReportAttachmentPreviewApiFp(configuration)
    return {
        /**
         * 
         * @summary Render a single PDF page as PNG with watermark (admin)
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamAttachmentPagePreview(attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPracticalExamAttachmentPagePreview(attachmentId, pageIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Number of pages in a PDF attachment (admin)
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamAttachmentPagesCount(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttachmentPagesCountDto> {
            return localVarFp.getPracticalExamAttachmentPagesCount(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Render a single PDF page from a shared attachment (public, via share token)
         * @param {string} token 
         * @param {number} attachmentId 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamSharedAttachmentPagePreview(token: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPracticalExamSharedAttachmentPagePreview(token, attachmentId, pageIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Number of pages in a shared PDF attachment (public, via share token)
         * @param {string} token 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamSharedAttachmentPagesCount(token: string, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttachmentPagesCountDto> {
            return localVarFp.getPracticalExamSharedAttachmentPagesCount(token, attachmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamReportAttachmentPreviewApi - interface
 * @export
 * @interface PracticalExamReportAttachmentPreviewApi
 */
export interface PracticalExamReportAttachmentPreviewApiInterface {
    /**
     * 
     * @summary Render a single PDF page as PNG with watermark (admin)
     * @param {number} attachmentId 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApiInterface
     */
    getPracticalExamAttachmentPagePreview(attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Number of pages in a PDF attachment (admin)
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApiInterface
     */
    getPracticalExamAttachmentPagesCount(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttachmentPagesCountDto>;

    /**
     * 
     * @summary Render a single PDF page from a shared attachment (public, via share token)
     * @param {string} token 
     * @param {number} attachmentId 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApiInterface
     */
    getPracticalExamSharedAttachmentPagePreview(token: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Number of pages in a shared PDF attachment (public, via share token)
     * @param {string} token 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApiInterface
     */
    getPracticalExamSharedAttachmentPagesCount(token: string, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttachmentPagesCountDto>;

}

/**
 * PracticalExamReportAttachmentPreviewApi - object-oriented interface
 * @export
 * @class PracticalExamReportAttachmentPreviewApi
 * @extends {BaseAPI}
 */
export class PracticalExamReportAttachmentPreviewApi extends BaseAPI implements PracticalExamReportAttachmentPreviewApiInterface {
    /**
     * 
     * @summary Render a single PDF page as PNG with watermark (admin)
     * @param {number} attachmentId 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApi
     */
    public getPracticalExamAttachmentPagePreview(attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig) {
        return PracticalExamReportAttachmentPreviewApiFp(this.configuration).getPracticalExamAttachmentPagePreview(attachmentId, pageIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Number of pages in a PDF attachment (admin)
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApi
     */
    public getPracticalExamAttachmentPagesCount(attachmentId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamReportAttachmentPreviewApiFp(this.configuration).getPracticalExamAttachmentPagesCount(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Render a single PDF page from a shared attachment (public, via share token)
     * @param {string} token 
     * @param {number} attachmentId 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApi
     */
    public getPracticalExamSharedAttachmentPagePreview(token: string, attachmentId: number, pageIndex: number, options?: RawAxiosRequestConfig) {
        return PracticalExamReportAttachmentPreviewApiFp(this.configuration).getPracticalExamSharedAttachmentPagePreview(token, attachmentId, pageIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Number of pages in a shared PDF attachment (public, via share token)
     * @param {string} token 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamReportAttachmentPreviewApi
     */
    public getPracticalExamSharedAttachmentPagesCount(token: string, attachmentId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamReportAttachmentPreviewApiFp(this.configuration).getPracticalExamSharedAttachmentPagesCount(token, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }
}

